module.exports = __webpack_public_path__ + "9978c5eab7982f5bb3f93b2174c59e0f.jpg";